/**
 * Service worker registration wrapper.
 * Registers only in production on a real deployment — never in Lovable
 * preview, dev, iframes, or when ?sw=off is present. Any refused context
 * actively unregisters stale /sw.js registrations so previews don't get
 * stuck serving cached HTML.
 */
const SW_URL = "/sw.js";

function isPreviewHost(hostname: string): boolean {
  return (
    hostname.startsWith("id-preview--") ||
    hostname.startsWith("preview--") ||
    hostname === "lovableproject.com" ||
    hostname.endsWith(".lovableproject.com") ||
    hostname === "lovableproject-dev.com" ||
    hostname.endsWith(".lovableproject-dev.com") ||
    hostname === "beta.lovable.dev" ||
    hostname.endsWith(".beta.lovable.dev")
  );
}

async function unregisterAppSW() {
  if (!("serviceWorker" in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      const scriptURL =
        reg.active?.scriptURL ||
        reg.installing?.scriptURL ||
        reg.waiting?.scriptURL ||
        "";
      if (scriptURL.endsWith(SW_URL)) {
        await reg.unregister();
      }
    }
  } catch {
    /* ignore */
  }
}

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const url = new URL(window.location.href);
  const isIframe = window.self !== window.top;
  const killSwitch = url.searchParams.get("sw") === "off";
  const refuse =
    !import.meta.env.PROD ||
    isIframe ||
    killSwitch ||
    isPreviewHost(window.location.hostname);

  if (refuse) {
    void unregisterAppSW();
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker.register(SW_URL).catch((err) => {
      console.warn("SW registration failed", err);
    });
  });
}